<script>
import axios from 'axios'
import {authComputed} from "@state/helpers";

export default {
  props: {
    camera: {
      type: Object,
      required: true,
    },
    loadingSize: {
      type: String,
      default: '100px',
    }
  },
  data() {
    return {
      imageSrc: '',
      loading: true,
      loadingColor: this.$style['color-primary'],
      message: '',
      interval: false
    }
  },
  computed: {
    ...authComputed
  },
  mounted() {
    if (this.camera) {
      this.interval = setInterval(() => {
        axios.get(`/data/api/panorama/${this.camera.uuid}/latest`,
            {headers: {Authorization: `Bearer ${this.currentUser.jwt}`}}
        ).then((response) => {
          if ('image' in response.data && response.data.image) {
            this.imageSrc = response.data.image
            this.loading = false
            this.$emit('latestSnapshotTime', new Date(`${response.data.timestamp}+00:00`));
          } else {
            this.message = 'No panorama image found.'
            this.loading = false
            this.$emit('latestSnapshotTime', new Date(0));
          }
        }).catch(() => {
          this.message = 'No panorama image found.'
          this.loading = false
          this.$emit('latestSnapshotTime', new Date(0));
        });
      }, 5000);
    }else{
      this.loading = false;
    }
  },
  destroyed() {
    if(this.interval !== false) {
      clearInterval(this.interval);
    }
  },
  methods: {
    onClick(event){
      this.$emit('click', event);
    }
  },
}
</script>

<template>
  <div
    :class="$style.panorama"
  >
    <BounceLoader
      :loading="loading"
      :color="loadingColor"
      :size="loadingSize"
      :class="$style.loading"
    ></BounceLoader>
    <div :class="$style.overlayBox">
      <img v-if="imageSrc" :src="imageSrc" :alt="'Panorama image ' + camera.name" @click="onClick"/>
    </div>
    <span v-if="message">{{ message }}</span>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.overlayBox {
  position: relative; display: flex; justify-content: center; align-items: center;
}

.overlay {
  margin: 0;
  position: absolute;
}
.overlay::before {
  content: "";
  display: block;
  position: absolute;
  top: -20em;
  left: -20em;
  width: 40em;
  height: 40em;
  background: rgba(255,0,0,0.5);
}

.panorama {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  color: transparentize($color-white, 0.6);

  img {
    display: flex;
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
  }
}
</style>
